import React from 'react'

const EditorPage = () => (
  <div>This version of content editor is obsolete. Please update the app.</div>
)

export default EditorPage
